export default __webpack_public_path__ + "static/media/phase1.7318c611.png";